import {
  AUTH_SERVER_ERROR,
  AUTH_SERVER_ERROR_MODAL_OPEN,
} from '../reducers/auth/authActions';
import { retrieveRequestId } from '../reducers/auth/authAuthorizeHelpers';
import { selectRequestId } from '../reducers/auth/authSelectors';

const authErrorMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === AUTH_SERVER_ERROR) {
    // Use the unique request ID (x-req-id) that was sent with the request
    const uniqueIdentifier = retrieveRequestId() || selectRequestId(store.getState());
    store.dispatch({
      type: AUTH_SERVER_ERROR_MODAL_OPEN,
      payload: { uniqueIdentifier },
    });
  }

  return result;
};

export default authErrorMiddleware;
